import Constants from '../utils/Constants';

export const usersValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('auctions.bids-list.place-bid.validation.users-empty');
    }
    return err;
};

export const USER_CODE_MAX_LENGTH = 6;
export const USER_CODE_ALLOWED_CHARS = /^[a-zA-Z0-9]*$/;
export const userCodeValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('users.validation.user-code-empty');
    } else if (input.length > USER_CODE_MAX_LENGTH) {
        err = t('users.validation.user-code-too-long', { maxLetters: USER_CODE_MAX_LENGTH });
    } else if (input.match(USER_CODE_ALLOWED_CHARS) === null) {
        err = t('users.validation.user-code-invalid');
    }
    return err;
};

export const USER_ID_INTERNAL_REGEX = /^[a-z]{2}[0-9]{3}(_t[0-3])?$/;
export const USER_ID_ALLOWED_CHARS = /^[a-zA-Z0-9_]*$/;
export const USER_ID_MAX_LENGTH = 8;
export const userIdValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('users.validation.user-id-empty');
    } else if (input.length > USER_ID_MAX_LENGTH) {
        err = t('users.validation.user-id-too-long', { maxLetters: USER_ID_MAX_LENGTH });
    } else if (input.match(USER_ID_ALLOWED_CHARS) === null) {
        err = t('users.validation.user-id-invalid');
    } else if (input.match(USER_ID_INTERNAL_REGEX) !== null) {
        err = t('users.validation.user-id-internal-user');
    }
    return err;
};

export const universalUserIdValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('users.validation.user-id-empty');
    } else if (input.length > USER_ID_MAX_LENGTH) {
        err = t('users.validation.user-id-too-long', { maxLetters: USER_ID_MAX_LENGTH });
    } else if (input.match(USER_ID_ALLOWED_CHARS) === null) {
        err = t('users.validation.user-id-invalid');
    }
    return err;
};

export const USER_NAME_MAX_LENGTH = 128;
export const userNameValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('users.validation.user-name-empty');
    } else if (input.length > USER_NAME_MAX_LENGTH) {
        err = t('users.validation.user-name-too-long', { maxLetters: USER_NAME_MAX_LENGTH });
    }
    return err;
};

export const USER_EMAIL_MAX_LENGTH = 254;
export const userEmailValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('users.validation.user-email-empty');
    } else if (!Constants.EMAIL_REGEX.test(input)) {
        err = t('users.validation.user-email-invalid');
    }
    return err;
};

export const USER_PHONE_MAX_LENGTH = 64;
export const userPhoneValidator = (t) => (input) => {
    let err = null;
    if (input.length > USER_PHONE_MAX_LENGTH) {
        err = t('users.validation.user-phone-too-long', { maxLetters: USER_PHONE_MAX_LENGTH });
    } else if (input.match('^[0-9-/; ()+]*$') === null) {
        err = t('users.validation.user-phone-invalid-format', { allowedChars: '0-9-/; ()+' });
    }
    return err;
};

export const USER_ADDRESS_MAX_LENGTH = 512;
export const userAddressValidator = (t) => (input) => {
    let err = null;
    if (input.length > USER_ADDRESS_MAX_LENGTH) {
        err = t('users.validation.user-address-too-long', { maxLetters: USER_ADDRESS_MAX_LENGTH });
    }
    return err;
};
